/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 13:58:27
 * @LastEditors: linxi
 */
import { EditOutlined,  } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Modal,
  ModalProps,
  Steps,
  Cascader as Cascaded,
  message,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import {
  getDecoctingPersonalSettingAsync,
  getPreferencesUpgradeAsync,
  getTenantPreferencesListAsync,
} from '../recipeEditorSlice'
import styles from './RecipeItemModal.module.css'

const DEFAULT_LOCAL_PREFERENCE_ID = 'default-local-preference'
const DEFAULT_LOCAL_PREFERENCE = {
  id: DEFAULT_LOCAL_PREFERENCE_ID,
  potionType: 0,
  potionTypeName: '本地代煎',
  machiningType: 4,
  isDefaultLocalPreference: true,
}

interface ReplaceMakeSettingModalProps {
  recipeId?: number
  patientId?: number
  recipeCategory?: number
  isSetting?: boolean
  isOpenReplaceMake?: any
  onOk?: () => void
  onCancel?: () => void
  addPersionalMessage?: (potionType?: any, supplierId?: any, id?: any) => void
  visible?: boolean
}

export const AddOrEditDecoctingPersionalSettingModal = ({
  recipeId,
  patientId,
  recipeCategory,
  isSetting,
  isOpenReplaceMake,
  onOk,
  onCancel,
  addPersionalMessage,
  visible,
}: ReplaceMakeSettingModalProps & ModalProps): ReactElement => {
  const { Step } = Steps

  const dispatch = useDispatch<RootDispatch>()

  const [messageApi, contextHolder] = message.useMessage()

  const [selectId, setSelectId] = useState<any>()

  const [selectPotionType, setSelectPotionType] = useState<any>()

  const [dataList, setDataList] = useState<any>()

  const getPreferenceName = (item: any) => {
    return item?.potionType == 2 || item?.potionType == 0
      ? item?.potionTypeName
      : item?.supplierName
  }

  const formatPreferenceList = (list: any[] = []) => {
    const sourceList = Array.isArray(list) ? list : []
    const localList = sourceList.filter((item: any) => item?.potionType == 0)
    const otherList = sourceList.filter((item: any) => item?.potionType != 0)
    const nextLocalList = localList.length ? localList : [DEFAULT_LOCAL_PREFERENCE]

    return [...otherList, ...nextLocalList]
  }

  const getTenantPreferencesList = () => {
    return dispatch(getTenantPreferencesListAsync())
      .then(unwrapResult)
      .then((v: any) => {
        const nextDataList = formatPreferenceList(v)
        setDataList(nextDataList)
        const defaultSelectedData = nextDataList?.filter((item: any) => {
          return item?.defaultSelected == 1
        })
        setSelectId(defaultSelectedData?.[0]?.id)
        setSelectPotionType(defaultSelectedData?.[0]?.potionType)
        return nextDataList
      })
  }

  const setDefaultPreference = (item: any) => {
    setSelectId(item?.id)
    setSelectPotionType(item?.potionType)
    if (item?.isDefaultLocalPreference) {
      dispatch(
        getDecoctingPersonalSettingAsync({
          potionType: 0,
          machiningType: 4,
          treatmentServiceCatalogId: '0',
          defaultSelected: 1,
          includeDecoctionFee: 0,
        })
      )
        .then(unwrapResult)
        .then(() => {
          messageApi.open({
            type: 'success',
            content: '已设置本地代煎为默认代煎方式',
            className: 'custom-class',
          })
          getTenantPreferencesList()
        })
      return
    }

    dispatch(getPreferencesUpgradeAsync(item?.id))
      .then(unwrapResult)
      .then((val) => {
        messageApi.open({
          type: 'success',
          content: '已设置' + getPreferenceName(item) + '为默认代煎方式',
          className: 'custom-class',
        })
      })
  }

  useEffect(() => {
    if (visible) {
      localStorage.setItem('notUseGlobalKeyboardAction', 'true')
      // 获取机构支持的代煎方式
      getTenantPreferencesList()
    }
  }, [visible])

  const reset = () => {
    localStorage.setItem('notUseGlobalKeyboardAction', 'false')
    setSelectId('')
  }

  return (
    <>
      {contextHolder}
      <Modal
        visible={visible}
        title='代煎偏好设置'
        width={400}
        maskClosable={false}
        footer={null}
        className={styles.persionalSetting}
        destroyOnClose
        style={{ overflow: 'hidden', padding: '0' }}
        bodyStyle={{
          padding: '30px 15px 0 15px',
          height: 580,
          overflow: 'auto',
        }}
        onCancel={(e) => {
          onCancel && onCancel(e)
          reset()
        }}
        onOk={(e) => {
          onOk && onOk()
          reset()
        }}
      >
        <div className={styles.mainContent}>
          <div className={styles.mainTopContent}>
            {dataList?.length ? (
              dataList?.map((v: any, index: any) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <div
                        key={index}
                        className={
                          selectId == v?.id
                            ? styles.selectBackContent
                            : styles.backContent
                        }
                        onClick={() => {
                          setDefaultPreference(v)
                        }}
                      >
                        {getPreferenceName(v)}
                      </div>
                      <div
                        className={styles.iconBackContent}
                        onClick={() => {
                          setSelectPotionType(v?.potionType)
                          localStorage.setItem(
                            'notUseGlobalKeyboardAction',
                            'false'
                          )
                          addPersionalMessage &&
                            addPersionalMessage(
                              v?.potionType,
                              v?.supplierId,
                              v?.isDefaultLocalPreference ? '' : v?.id
                            )
                        }}
                      >
                        <EditOutlined />
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div style={{ marginTop: '150px', color: '#B2B2B2' }}>
                尚未添加偏好设置
              </div>
            )}
          </div>
          {/* <div className={styles.bottonButton}>
            <Button
              style={{ height: '40px' }}
              className={styles.cancelBackContent}
              onClick={() => {
                onCancel && onCancel()
                reset()
              }}
            >
              取消
            </Button>
            <Button
              ghost
              type='primary'
              style={{ height: '40px' }}
              disabled={!isOpenReplaceMake ? true : false}
              className={styles.addBackContent}
              onClick={() => {
                addPersionalMessage && addPersionalMessage(selectPotionType, '')
                localStorage.setItem('notUseGlobalKeyboardAction', 'false')
              }}
            >
              <PlusOutlined />
              添加偏好
            </Button>
          </div> */}

        </div>
        <div style={{float:"left",color:"gray",fontStyle:"italic"}}>
          <span>点击饮片厂对应的按钮可以设置为默认饮片厂</span>
          <br/>
          <span>点击右侧的编辑按钮设置具体默认值</span>
        </div>
      </Modal>
    </>
  )
}
